
import Base from "../../base/Base.vue";
export default class InfoProfile extends Base {}
